import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import HeroSectionWithText from "../LandingPage/Components/HeroSectionWithText";
import HeroSectionWithButton from "./Components/HeroSectionWithButton";
import ShowcaseSection from "./Components/ShowcaseSection";
import ImageAndTextSectionWithHeader from "./Components/ImageAndTextSectionWithHeader";
import React from "react";
import { useTranslation } from "react-i18next";

const SkillAnalytics = () => {
  const { t } = useTranslation();

  const showcaseList = [
    {
      icon: "product-personality-inventory",
      text: t("landing.skillAnalytics.showcase.personalityInventories"),
    },
    {
      icon: "product-capability-inventory",
      text: t("landing.skillAnalytics.showcase.competencyInventories"),
    },
    {
      icon: "product-general-skill-test",
      text: t("landing.skillAnalytics.showcase.generalAbilityTests"),
    },
    {
      icon: "product-language-test",
      text: t("landing.skillAnalytics.showcase.languageTests"),
    },
    {
      icon: "product-test-library",
      text: t("landing.skillAnalytics.showcase.testLibrary"),
    },
    {
      icon: "product-assessment-center",
      text: t("landing.skillAnalytics.showcase.assessmentCenter"),
    },
  ];
  return (
    <div className={"p-0"}>
      <HeroSectionWithButton
        imageSrc={"/LandingPageImages/cusproLaptopOnATable.webp"}
        isImageOnRight={true}
        headerText={t("landing.skillAnalytics.hero.title")}
      >
        {t("landing.skillAnalytics.hero.description")}
      </HeroSectionWithButton>

      <HeroSectionWithText imageSrc={"/LandingPageImages/girlWithLaptopV2.webp"}>
        {t("landing.skillAnalytics.challenge.text")}
      </HeroSectionWithText>

      <Row className={"justify-content-center text-center mx-0"}>
        <Col xs={"auto"} className={"mt-5 EB-Garamond text-36 text-lg-50"}>
          {t("landing.skillAnalytics.productsTitle")}
        </Col>
      </Row>

      <ShowcaseSection showcaseList={showcaseList}></ShowcaseSection>

      <ImageAndTextSectionWithHeader
        imageSrc={"/LandingPageImages/colorPaletteGirl.webp"}
        bottomText={t("landing.skillAnalytics.personalityInventories.bottomText")}
        header={t("landing.skillAnalytics.personalityInventories.header")}
        text={t("landing.skillAnalytics.personalityInventories.text")}
      ></ImageAndTextSectionWithHeader>

      <Row className={"justify-content-center mx-0 my-5"}>
        <Col
          xs={12}
          md={11}
          lg={10}
          xl={9}
          xxl={8}
          className={"text-center text-22 text-lg-32 EB-Garamond fw-medium text-black"}
        >
          <div
            className={"position-relative "}
            style={{
              padding: "1px",
              borderRadius: "25px",
              background: "linear-gradient(to bottom, #B9D5F6, #E6F2FE)",
            }}
          >
            <Row
              className={"mx-0 py-5 bg-white justify-content-center"}
              style={{
                background: "linear-gradient(to bottom, #F3F8FD, #FDFEFF)",
                borderRadius: "24px",
              }}
            >
              <Col xs={11} md={8}>
                {t("landing.skillAnalytics.personalityInventories.quote")}
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      <ImageAndTextSectionWithHeader
        imageSrc={"/LandingPageImages/statisticsMeeting.webp"}
        header={t("landing.skillAnalytics.generalAbilityTests.header")}
        text={t("landing.skillAnalytics.generalAbilityTests.text")}
      ></ImageAndTextSectionWithHeader>
      <Row className={"justify-content-center mx-0 my-5"}>
        <Col
          xs={12}
          md={11}
          lg={10}
          xl={9}
          xxl={8}
          className={"text-center text-22 text-lg-32 EB-Garamond fw-medium text-black"}
        >
          <div
            className={"position-relative "}
            style={{
              padding: "1px",
              borderRadius: "25px",
              background: "linear-gradient(to bottom, #B9D5F6, #E6F2FE)",
            }}
          >
            <Row
              className={"mx-0 py-5 bg-white justify-content-center"}
              style={{
                background: "linear-gradient(to bottom, #F3F8FD, #FDFEFF)",
                borderRadius: "24px",
              }}
            >
              <Col xs={11} md={8}>
                {t("landing.skillAnalytics.generalAbilityTests.quote")}
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      <ImageAndTextSectionWithHeader
        imageSrc={"/LandingPageImages/womenSmilingAtATablet.webp"}
        header={t("landing.skillAnalytics.languageTests.header")}
        text={t("landing.skillAnalytics.languageTests.text")}
      ></ImageAndTextSectionWithHeader>

      <ImageAndTextSectionWithHeader
        imageSrc={"/LandingPageImages/womenSmilingAtATabletOutdoors.webp"}
        header={t("landing.skillAnalytics.testLibrary.header")}
        text={t("landing.skillAnalytics.testLibrary.text")}
      ></ImageAndTextSectionWithHeader>

      <ImageAndTextSectionWithHeader
        imageSrc={"/LandingPageImages/officeDeskSpace.webp"}
        header={t("landing.skillAnalytics.assessmentCenter.header")}
        text={t("landing.skillAnalytics.assessmentCenter.text")}
      ></ImageAndTextSectionWithHeader>
    </div>
  );
};
export default SkillAnalytics;
